import request, { PATCH } from '../../utils/request';

export default body => request('/receptacles/invoices', { method: PATCH, body });
